<template>
  <div
    :class="classes"
    class="trade-book-and-history-block"
  >
    <trade-top-heading-block
      class="trade-book-and-history-block__mobile-title pt-10 pb-10 pl-10 pr-10 txt--color-04 txt--12px bor--bottom bor--transp-01"
    >
      <span class="trade-book-and-history-block__book-name">
        {{ $t('trade.orderBook') }}
      </span>

      <div class="trade-book-and-history-block__tabs-mobile">
        <trade-tabs-switcher
          v-model="bookOrHistory"
          :buttons="btns"
        />
      </div>

      <div
        :class="{'trade-book-and-history-block--hide-last-orders': bookOrHistory.value !== '--book-orders'}"
        class="trade-last-orders__tabs"
      >
        <trade-last-orders-tabs />
      </div>
    </trade-top-heading-block>

    <div class="trade-book-and-history-block__content">
      <trade-last-orders class="trade-book-and-history-block__book" />

      <trade-history
        hide-title-breakpoint="1366px"
        class="trade-book-and-history-block__history bor--right-none--s bor--left--s bor--transp-01"
      />
    </div>
  </div>
</template>

<script>
import { LabeledValue } from '@/data-objects/props/LabeledValue'

export default {
  name: 'TradeBookAndHistoryBlock',
  components: {
    TradeTabsSwitcher: () => import(/* webpackMode: "eager" */ '@/components/trade/TradeTabsSwitcher.vue'),
    TradeHistory: () => import(/* webpackMode: "eager" */ '@/components/trade/TradeHistory.vue'),
    TradeLastOrders: () => import(/* webpackMode: "eager" */ '@/components/trade/TradeLastOrders.vue'),
    TradeTopHeadingBlock: () => import(/* webpackMode: "eager" */ '@/components/trade/TradeTopHeadingBlock.vue'),
    TradeLastOrdersTabs: () => import(/* webpackMode: "eager" */ '@/components/trade/trade-last-orders-elements/TradeLastOrdersTabs.vue'),
  },
  data () {
    return {
      bookOrHistory: null,
    }
  },
  computed: {
    btns () {
      return [
        new LabeledValue(this.$t('trade.orderBook'), '--book-orders'),
        new LabeledValue(this.$t('trade.marketHistory'), '--trade-history'),
      ]
    },
    classes () {
      if (!this.bookOrHistory) return {}
      return {
        [`trade-book-and-history-block${this.bookOrHistory.value}`]: this.bookOrHistory,
      }
    },
  },
  watch: {
    btns: 'setCurrentItem',
  },
  created () {
    this.setCurrentItem()
  },
  methods: {
    setCurrentItem () {
      this.bookOrHistory = this.btns[0]
    },
  },
}
</script>

<style lang="scss" scoped>
.trade-book-and-history-block {
  $root: &;

  width: 100%;
  $laptop-screen: 1366px;
  $bottom-padding: 18px;

  &__content {
    display: flex;
    height: calc(100% - #{$h-Header} + #{$bottom-padding});

    @include bp($laptop-screen) {
      height: 100%;
    }
  }

  &__book-name {
    display: none;

    @include bp(m) {
      display: none;
    }
  }

  // always show this three options on mobile
  &--hide-last-orders {
    @include bp(m) {
      display: none;
    }
  }

  &__tabs-mobile {
    @include bp(m) {
      display: block;
    }
  }

  &__mobile-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @include bp($laptop-screen) {
      display: none;
    }
  }

  &--trade-history {
    #{$root}__history {

    }

    #{$root}__book {
      display: none;

      @include bp($laptop-screen) {
        display: block;
      }
    }
  }

  &--book-orders {
    #{$root}__history {
      display: none;

      @include bp($laptop-screen) {
        display: block;
      }
    }
  }

  &--hide-last-orders {
    display: none;
  }
}
</style>
